import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core'
import { SafeHtml, DomSanitizer } from "@angular/platform-browser"
import { Subscription } from 'rxjs'
import { ApiService } from '../api.service'
import { TinymceEditorComponent } from "../tinymce-editor/tinymce-editor.component"
import Swal from 'sweetalert2'

@Component({
	selector: 'heading',
	templateUrl: './heading.component.html',
	styleUrls: ['./heading.component.scss']
})

export class HeadingComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	userAI = false
	
	@Input() id = 0
	@Input() type = 'heading'
	@Input() course = 0
	@Input() lesson = 0
	@Input() unit = 0
	@Input() multitransl = false
	@Input() transl = 'es'
	lessonName = ''
	unitName = ''

	loading = true
	error = false
	heading = false
	summary = false
	caseStudy = false

	name = ''
	content = ''
	contentMedia: SafeHtml = ''
	contentEmpty = false
	term = ''
	imgNoAlt = false
	imgNoSource = false
	wordCount = 0
	
	editing = false
	// tables = false
	files = false

	@ViewChild('headingRecommendMultimediaDialog', { static: true }) headingRecommendMultimediaDialog!: ElementRef<HTMLDialogElement>
	recommendMultimedia = false
	recommendMultimediaType = ''
	recommendMultimediaKeywords = ''
	recommendMultimediaHeading = 0

	@ViewChild('diagramDialog', { static: true }) diagramDialog!: ElementRef<HTMLDialogElement>
	diagram = false
	diagramHeading = 0

	showCriteria = false
	criteria: any[] = []
	selectedCriteria: any[] = []

	generateContentLoading = false
	generateContentSuccess = false
	generateContentError = false
	generateImageLoading = false
	generateImageSuccess = false
	generateImageError = false

	getSub = new Subscription
	previewSub = new Subscription
	updateSub = new Subscription
	saveCriteriaSub = new Subscription
	generateContentAISub = new Subscription
	generateImageAISub = new Subscription
	extractPhrasesSub = new Subscription

	@ViewChild(TinymceEditorComponent) tinymceEditor: any
	headingContentEditorId = 'heading-content-editor'
	summaryContentEditorId = 'summary-content-editor'

	@Output() onClose: EventEmitter<boolean> = new EventEmitter

	constructor(private dataService: ApiService, private sanitizer: DomSanitizer) { }

	ngOnInit(): void {
		this.userAI = this.dataService.getUserAI()
	}

	ngAfterViewInit(): void {}

	ngOnChanges(): void {
		if (this.id == 0) return

		this.generateContentLoading = false
		this.generateContentSuccess = false
		this.generateContentError = false
		this.generateImageLoading = false
		this.generateImageSuccess = false
		this.generateImageError = false

		// console.log(this.type)
		this.heading = this.type == 'heading'
		this.caseStudy = this.type.includes('case_study')
		this.summary = this.type == 'summary'

		this.showHeading(this.id)

		this.changeEditing(false)
		this.generateContentLoading = false
		this.generateContentSuccess = false
		this.generateContentError = false
	}

	ngOnDestroy(): void {
		this.getSub?.unsubscribe()
		this.previewSub?.unsubscribe()
		this.updateSub?.unsubscribe()
		this.saveCriteriaSub?.unsubscribe()
		this.generateContentAISub?.unsubscribe()
		this.generateImageAISub?.unsubscribe()
		this.extractPhrasesSub?.unsubscribe()
	}

	close() {
		this.onClose.emit(true)
	}

	hideAll() {
		this.editing = false
		// this.tables = false
		this.files = false
		this.generateContentLoading = false
		this.generateContentSuccess = false
		this.generateContentError = false
	}

	showHeading(id: number) {
		this.loading = true
		if (this.heading || this.caseStudy) {
			this.getSub = this.dataService.showHeading(id, this.multitransl, this.transl)
			.subscribe({
				next: (data) => {
					// console.log(data)
					this.loading = false
					this.error = false

					// this.id = data.id
					this.name = data.name
					this.content = data.content
					this.contentEmpty = data.content.length == 0
					this.contentMedia = this.sanitizer.bypassSecurityTrustHtml(data.content_media)
					this.term = data.term
					this.lesson = data.lesson.id
					this.lessonName = data.lesson.name
					this.unit = data.unit.id
					this.unitName = data.unit.name
					if (this.course == 0) this.course = data.course.id
					this.imgNoAlt = data.no_alt
					this.imgNoSource = data.no_source
					this.wordCount = data.word_count

					if (this.caseStudy) {
						this.criteria = data.criteria
						this.selectedCriteria = data.selected_criteria
					}
				},
				error: (_e) => {
					// console.log(e)
					this.loading = false
					this.error = true
				},
			})
		} else if (this.summary) {
			this.getSub = this.dataService.showSummary(id, this.multitransl, this.transl)
			.subscribe({
				next: (data) => {
					// console.log(data)
					this.loading = false
					this.error = false

					// this.id = data.id
					this.name = data.name
					this.content = data.content
					this.contentEmpty = data.content.length == 0
					this.contentMedia = this.sanitizer.bypassSecurityTrustHtml(data.content_media)
					this.unit = data.unit.id
					this.unitName = data.unit.name
					if (this.course == 0) this.course = data.course.id
					this.wordCount = data.word_count
				},
				error: (_e) => {
					// console.log(e)
					this.loading = false
					this.error = true
				},
			})
		}
	}

	async changeEditing(editing: boolean) {
		if (!editing) {
			let contentChanged = this.tinymceEditor?.isEditorDirty(this.headingContentEditorId)

			if (contentChanged) {
				await Swal.fire({
					title: 'Cuidado',
					text: 'No ha guardado los cambios hechos a este enunciado. Pulse \'Aceptar\' para continuar editando, o pulse \'Cancelar\' para descartar los cambios.',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonText: 'Aceptar',
					cancelButtonText: 'Cancelar'
				}).then((result) => {
					// console.log(result)
					editing = result.isConfirmed
					this.editing = editing
				})
			}
		}

		this.editing = editing
	}

	showMultimedia() {
		let dialog = document.getElementById('heading-multimedia-dialog') as HTMLDialogElement
		dialog.showModal()
	}

	showFiles() {
		let dialog = document.getElementById('heading-files-dialog') as HTMLDialogElement
		dialog.showModal()
	}

	openRecommendMultimedia(type: string) {
		this.recommendMultimediaKeywords = this.term
		this.recommendMultimedia = true
		this.recommendMultimediaType = type
		this.recommendMultimediaHeading = this.id
		this.headingRecommendMultimediaDialog.nativeElement.showModal()
	}

	closeRecommendMultimedia() {
		this.headingRecommendMultimediaDialog.nativeElement.close()
		this.recommendMultimedia = false
		this.showHeading(this.id)
	}

	openDiagram() {
		this.diagram = true
		this.diagramHeading = this.id
		this.diagramDialog.nativeElement.showModal()
	}

	closeDiagram() {
		this.diagramDialog.nativeElement.close()
		this.diagram = false
		this.diagramHeading = 0
		this.showHeading(this.id)
	}

	/*
	showTables(lesson: number) {
		this.lesson = lesson
		this.hideAll()
		this.tables = true
	}
	*/

	preview(content: string) {
		this.previewSub = this.dataService.previewHeading(content)
		.subscribe({
			next: (data) => {
				let newWindow = window.open()
				newWindow?.document.write('<title>Previsualización de enunciado</title>')
				newWindow?.document.write(data)
				newWindow?.document.write('<div><button onclick="window.close()">Cerrar</button></div>')
			},
			error: (_e) => {
				// console.log(e)
			},
		})
	}

	update(id: number, content: string) {
		// console.log(id)
		// console.log(content)

		if (content.length == 0) {
			Swal.fire('Error', 'No puede dejar el contenido vacío.', 'error')
			return
		}

		if (this.heading || this.caseStudy) {
			this.updateSub = this.dataService.updateHeading(id, undefined, content, this.multitransl, this.transl)
			.subscribe({
				next: (data) => {
					// console.log(data)
					this.hideAll()
					this.content = data.content
					this.contentMedia = this.sanitizer.bypassSecurityTrustHtml(data.content_media)
					this.contentEmpty = data.content.length == 0
					this.imgNoAlt = data.no_alt
					this.imgNoSource = data.no_source
					this.wordCount = data.word_count
				},
				error: (_e) => {
					// console.log(_e)
				},
			})
		} else if (this.summary) {
			this.updateSub = this.dataService.updateSummary(id, undefined, content, this.multitransl, this.transl)
			.subscribe({
				next: (data) => {
					// console.log(data)
					this.hideAll()
					this.content = data.content
					this.contentMedia = this.sanitizer.bypassSecurityTrustHtml(data.content_media)
					this.contentEmpty = data.content.length == 0
					this.wordCount = data.word_count
				},
				error: (_e) => {
					// console.log(_e)
				},
			})
		}
	}

	checkCriteria(event: Event) {
		let input = event.currentTarget! as HTMLInputElement
		let name = input.name
		let checkedCriteriaInputs = document.querySelectorAll(`input[type="checkbox"][name="${name}"]:checked`)

		let checkedCriteriaStr = ""
		checkedCriteriaInputs.forEach((input) => {
			checkedCriteriaStr += input.getAttribute('value') + ", "
		})
		checkedCriteriaStr = checkedCriteriaStr.slice(0, -2)

		this.saveCriteriaSub = this.dataService.saveCaseStudyCriteria(this.id, checkedCriteriaStr)
		.subscribe(
			_data => {
				// console.log(data)
			},
			_error => {
				// console.log(error)
			},
		)
	}

	async generateContentAI() {
		let generate = true
		if (!this.contentEmpty) {
			generate = await Swal.fire({
				title: '¿Seguro?',
				text: 'Se borrará el contenido existente. ¿Está seguro de querer generar contenido nuevo?',
				icon: 'question',
				showCancelButton: true,
				cancelButtonText: 'Cancelar'
			}).then((result) => {
				// console.log(result)
				return result.isConfirmed
			})
		}

		if (!generate) return
		
		this.generateContentLoading = true
		this.generateContentSuccess = false
		this.generateContentError = false

		this.generateContentAISub = this.dataService.generateHeadingContentAI(this.id)
		.subscribe(
			data => {
				// console.log(data)
				// console.log(length)
				this.contentEmpty = data.content.length == 0
	
				this.generateContentSuccess = true
				this.generateContentLoading = false
				this.generateContentError = false
	
				this.content = data.content
				this.contentMedia = data.content
				this.wordCount = data.word_count
			},
			error => {
				console.log(error)
	
				this.generateContentError = true
				this.generateContentLoading = false
				this.generateContentSuccess = false
			},
		)
	}

	generateImageAI() {
		this.generateImageLoading = true
		this.generateImageSuccess = false
		this.generateImageError = false

		this.generateImageAISub = this.dataService.generateHeadingImageAI(this.course, this.lesson, this.id, this.content)
		.subscribe(
			data => {
				// console.log(data)
				// console.log(length)
				this.content = data.content
				this.contentMedia = data.content_media
				this.contentEmpty = data.content.length == 0

				this.generateImageSuccess = true
				this.generateImageLoading = false
				this.generateImageError = false

				// this.content = data.content
				// this.contentMedia = data.content
				// this.wordCount = data.word_count
			},
			error => {
				console.log(error)

				this.generateImageError = true
				this.generateImageLoading = false
				this.generateImageSuccess = false
			},
		)
	}

}
